var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6818 0H2.31818C1.31364 0 0.5 0.813636 0.5 1.81818V18.1818C0.5 19.1864 1.31364 20 2.31818 20H11.4091V11.8182H8.68182V9.09091H11.4091V7.62636C11.4091 4.85364 12.76 3.63636 15.0645 3.63636C16.1682 3.63636 16.7518 3.71818 17.0282 3.75545V6.36364H15.4564C14.4782 6.36364 14.1364 6.88 14.1364 7.92546V9.09091H17.0036L16.6145 11.8182H14.1364V20H18.6818C19.6864 20 20.5 19.1864 20.5 18.1818V1.81818C20.5 0.813636 19.6855 0 18.6818 0Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.80323d0991c97ae676934ce48735197b.svg";
export { ForwardRef as ReactComponent };